import React from 'react';
import ReactDOM from 'react-dom/client'; 
import { BrowserRouter as Router } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import App from './App';

dayjs.locale('pt-br');

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

root.render(
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
    <Router>
      <App />
    </Router>
  </LocalizationProvider>
);